import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
//import { tap } from 'lodash';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { ProjectDto, ProjectToAdd } from 'projects/shared/src/lib/models/Project';
import { TenantDto, UserTenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { debounceTime, switchMap, finalize, tap } from 'rxjs/operators';
import { SelectUserpermissionDialogComponent } from '../../user-management/select-userpermission-dialog/select-userpermission-dialog/select-userpermission-dialog.component';
import { SelectUserpermissionsResult } from 'projects/shared/src/lib/models/SquirrelRoles';
import { group } from 'console';
import { SelectData } from 'projects/shared/src/lib/models/SelectData';

@Component({
  selector: 'add-project-dialog',
  templateUrl: './add-project-dialog.component.html',
  styleUrls: ['./add-project-dialog.component.scss']
})
export class AddProjectDialogComponent implements OnInit {

  projectCreationForm!: FormGroup;
  // public color: ThemePalette = 'primary';
  // public listColors = ['primary', 'accent', 'warn'];
  // public lat:number = 0.0;
  // public lon:number = 0.0;

  //tenants:TenantDto[] = [];
  _isadmin!:string;
  servers:string[] = [];
  serverName!:string;
  selectedServer!:string;
  isLoading = true;
  serverSelected = false;
  users:UserDto[] = [];
  userForm!: FormGroup;
  adminUserEmail:string = "";
  adminUserName:string = "";
  adminUserId:string = ""
  _userSelected = false;
  tenantScope!:string;
  currentPage = 1;
  pageSize = 10000;
  isFormCreated = false;
  isWPTenant = false;
  wpServerUrl!: string;
  wpTenant!: string;
  wpApiUser!: string;
  wpApiKey!: string;
  selectUserpermissionResult: SelectUserpermissionsResult = new SelectUserpermissionsResult();
  checkTemplates = false;
  isDataLoaded = false;
  isTemplateForAdmin = false;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddProjectDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public translate: TranslateService,
              private tenantService: TenantService,
              private notificationService: NotificationService,
              private dialog: MatDialog,
              private oauthService: OAuthServiceService) { }

  ngOnInit() {
      this.tenantService.getTenant(this.tenantService.currentTenantId).subscribe({
        next: (tenant:TenantDto) => {
          this.isWPTenant = tenant.systemType === 'WINPLAN';
          this.tenantScope = tenant.scopeName;
          this.wpServerUrl = tenant.wpServerUrl;
          this.wpTenant = tenant.wpTenant;
          this.wpApiUser = tenant.wpApiUser;
          this.wpApiKey = tenant.wpApiKey;

          this.tenantService.getServers(this.tenantService.currentTenantName, this.tenantScope).subscribe({
            next:(servers) => {
                // servers.forEach((server:string) => {
                //   this.servers.push(`${server}/tenantScope`);
                // });
                this.servers = servers;


                //getTenantGroupRoles for Admin
                this.tenantService.getProjectGroupRoleTemplatesForAdmin(this.tenantService.currentTenantName, new GenericFilter()).subscribe({
                  next: (grouproles) => {
                    console.log("---------------> project-role-templates for admin", grouproles)
        
                    if (grouproles.length > 0) {
                      this.isTemplateForAdmin = true;
                    }
                    this.isLoading = false;
                    this.isDataLoaded = true;
                    this.createProjectForm();
                    this.searchUser();
                    console.log("============> servers: ", this.servers);
                  },
                  error: (error: any) => {
                    this.isLoading = false;
                    this.isDataLoaded = true;
                    this.notificationService.error(`${this.translate.data["ERROR"]}`, "Getting project group role templates for admin failed!");
                    console.log("------> error: ", error.error.developerMessage)
                    this.notificationService.info("", error.error.developerMessage.Message)
                  }
                })

              },
            //error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTCLONEDERROR"]}`)
          })   
      }
    }) 
  }

  //  get admin(): string {
  //   this.oauthService.userData.subscribe({
  //     next: (data) => {
  //       if (typeof data != undefined && data != null) {
  //         let userRoles = data.role as Array<string>;
  //         userRoles.forEach((dbrole: string) => {
  //           if (dbrole === 'admin' ) {
  //             this._isadmin = dbrole;
  //           }
  //         });
  //       }
  //     }
  //   });
  //   return this._isadmin;
  // }

  createProjectForm(){
    console.log("---------> add-project-dialog: createProjectForm")
    this.projectCreationForm = this.formBuilder.group({
//      tenant:[null],
      name:[null, Validators.required],
      // latitude:[this.lat],
      // longitude:[this.lon],
      description:[null],
      adminUser:[null],
      wpProjectId: [null],
      //wpTenant: [null],
      wpServerUrl:[null]
    });
    this.isFormCreated = true;
  }

  searchUser() {
    console.log("---------> add-project-dialog: search  user")
    let searchText="";
      this.tenantService.loadTenantUsers(this.tenantService.tempTenantName, searchText, this.currentPage, this.pageSize).subscribe({
        next: (userDto: UserDto[]) => {
          this.users = userDto.sort((a, b) => (a.last_Name > b.last_Name) ? 1 : ((b.last_Name > a.last_Name) ? -1 : 0));
  //        this.rowData = this.userData.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));
  
          if(this.users.length > 0){
            //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["RETRIEVEDUSERS"]} `);
          }
          else{
            //console.log("No users found")
            this.notificationService.info(`${this.translate.data["INFO"]}`, "Keine weiteren Benutzer zur Suche vorhanden!");
          }        
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RETRIEVEUSERSERROR"]}`)
      });
  
      this.projectCreationForm.get('adminUser')?.valueChanges
        .pipe(debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap((value: any) => this.tenantService.loadTenantUsers(this.tenantService.tempTenantName, value, this.currentPage, this.pageSize)
            .pipe(finalize(() => this.isLoading = false))))
        .subscribe({
          next: (userDto: UserDto[]) => {
            this.users = userDto;
            console.log("------------> add-project-dialog: users = ", this.users);
            //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERFOUND"]} `);
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["INFO"]}`, `${this.translate.data["USERFOUNDERROR"]}`)
        });
    }
  
    displayFn(user: any) {
      console.log("displayFn: user = ", user)
      if (user) { return user.userName; }
    }
  
  add() {

    //     if (this.userForm.valid) {
    //   let newUserData = {userDto: this.userForm.value};
    //   newUserData.userDto.inclTGR = this.inclTGR;
    //   console.log("=========> user form value/userData", newUserData)
    //   this.selectUserpermissionResult.userData = newUserData;
    //   this._dialogRef.close(this.selectUserpermissionResult);
    // }


    if(this.isFormValid()){
      this.projectCreationForm.value.serverName = this.selectedServer+"/" + this.tenantScope;
      this.projectCreationForm.value.wpServerUrl = this.wpServerUrl;
      this.projectCreationForm.value.adminUserId = this.adminUserId;

          let newProject = new ProjectToAdd
          //newProject.id = result.id;
          newProject.name = this.projectCreationForm.value.name;
          newProject.description = this.projectCreationForm.value.description;
          newProject.serverName = this.projectCreationForm.value.serverName;
          newProject.adminUserId = this.projectCreationForm.value.adminUserId;
          newProject.wpProjectId = this.projectCreationForm.value.wpProjectId;
          newProject.wpTenant = this.wpTenant;
          newProject.wpServerUrl = this.projectCreationForm.value.wpServerUrl;
          newProject.wpApiUser = this.wpApiUser;
          newProject.wpApiKey = this.wpApiKey;
          console.log("-------> manage-project: addProject() newProject = ", newProject)

          if (this.selectUserpermissionResult.projRolePairs != null && this.selectUserpermissionResult.projRolePairs.length > 0) {
            newProject.projRolePairs = this.selectUserpermissionResult.projRolePairs;
            console.log("-------> manage-project: addProject() newProject with projRolePairs = ", newProject)
            this.tenantService.addProjectWithGrouproles(newProject, this.tenantService.tempTenantName).subscribe({
              next: (project: ProjectDto) => {
                this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTADDED"]}`);
                this.dialogRef.close(project);
              },
              error: (error: any) => {
                this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTADDERROR"]}`);
                console.log("------> error: ", error.error.developerMessage);
                this.notificationService.info("", error.error.developerMessage.Message);
              } 
            });
          } else {

            this.tenantService.addProject(newProject, this.tenantService.tempTenantName).subscribe({
              next: (project: ProjectDto) => {
                this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTADDED"]}`);
                this.dialogRef.close(project);
              },
              error: (error: any) => {
                this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTADDERROR"]}`);
                console.log("------> error: ", error.error.developerMessage);
                this.notificationService.info("", error.error.developerMessage.Message);
              } 
            });
          }


    }
  }

  isFormValid(){
    if (this.projectCreationForm) {
      return this.projectCreationForm.value.name && this.selectedServer != undefined && this.adminUserId != undefined;
      }
  }

  selectUserPermission() {
    let selectData = new SelectData();
    selectData.action = "selectTemplates";
    selectData.tenantName = this.tenantService.tempTenantName;
    //selectData.userId = this.adminUserId;
    //const dialogRef = this.dialog.open(SelectUserpermissionDialogComponent, { height: '800px', width: '800px', data: null, position: { top: '100px', left: '1200px' } });
    const dialogRef = this.dialog.open(SelectUserpermissionDialogComponent, { height: '600px', width: '800px', data: selectData});

    dialogRef.afterClosed().subscribe((result: any) => { 

      console.log("-----> add-project-dialog: Proj-Role Id-Pairs = ", result)
      this.selectUserpermissionResult.projRolePairs = result;
      if (result !== undefined) {
        this.add();
        dialogRef.close();
      } else { //Abbruch
        this.selectUserpermissionResult.projRolePairs = [];
        // this.isTemplateSelection = false;
        this._userSelected = false;
        //this.copyUserName = "";
        this.projectCreationForm.patchValue({adminUser: ""});
      }
      this.checkTemplates = false;
    },
    //error
    );
  }

  // onChange(event: any) {
  //   console.log("---------> add-project-dialog: onChange event = ", event)
  //   if(event.checked) {
  //     const dialogRef = this.dialog.open(SelectUserpermissionDialogComponent, { height: '800px', width: '800px', data: null, position: { top: '100px', left: '1200px' } });
  //     dialogRef.afterClosed().subscribe((result: any) => { 

  //       console.log("-----> add-project-dialog: Proj-Role Id-Pairs = ", result)
  //       this.selectUserpermissionResult.projRolePairs = result;
  //       if (result !== undefined) {
  //       } else { //Abbruch
  //         this.selectUserpermissionResult.projRolePairs = [];
  //         // this.isTemplateSelection = false;
  //       }
  //       this.checkTemplates = false;
  //     },
  //     //error
  //     );
  //   }  
  // }


  cancel() {
    this.dialogRef.close();
  }

  optionSelected(event: any) {
    console.log("event:", event);
    console.log("userId:", event.option.value.id);
    this.adminUserName = (event.option.value.emailConfirmed)?event.option.value.userName:event.option.value.email;
    this.adminUserEmail = event.option.value.email;
    this.adminUserId = event.option.value.id;
    //console.log("------------> add-project-dialog: adminUserId = ", this.adminUserId);
    this._userSelected = true;
  }

}
function subscribe(arg0: { next: (userDto: UserDto[]) => void; error: (error: any) => void; }) {
  throw new Error('Function not implemented.');
}

